import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApi } from '@/api/ApiContext';
import type { CloseShiftRequest } from '@/api/handlers/resources/shifts/requests';
import type { ShiftResponse } from '@/api/handlers/resources/shifts/responses';
import type { ApiResponse } from '@/api/handlers/responses';
import { ShiftQueryKeys } from './shiftQueryKeys';

/**
 * Closes the seller's open shift. Once it settles it invalidates the
 * current-shift query: on success the gate flips back to closed, and a refusal
 * re-reads too, because `NO_OPEN_SHIFT` means the shift was already closed
 * elsewhere (SEL-27). Branches on `result.success`; a rejected co-sign /
 * validation error comes back as a 400 `error`.
 */
export const useCloseShiftMutation = () => {
    const { apiClient } = useApi();
    const queryClient = useQueryClient();

    return useMutation<ApiResponse<ShiftResponse>, Error, CloseShiftRequest>({
        mutationFn: (body) => apiClient.shifts.close(body),
        onSettled: () => {
            void queryClient.invalidateQueries({
                queryKey: ShiftQueryKeys.current(),
            });
        },
    });
};
